import React, { FC } from 'react';

import { Stack } from '@mantine/core';

import { Component, isNonElectricalComponentType } from 'models';

import { Datasheet } from 'components/datasheet/Datasheet';
import { DatasheetMode, useDatasheetMode } from 'components/datasheet/DatasheetMode';

import {
    Certificates,
    Collateral,
    Communication,
    CompatibleWith,
    DistributorPricing,
    Electrical,
    Files,
    General,
    Images,
    Performance,
    Questions,
    ReferenceDesigns,
} from './sections';
import { Environmental } from './sections/Environmental';
import { Mechanical } from './sections/Mechanical';
import { ProductVariants } from './sections/ProductVariants';
import { Standards } from './sections/Standards';

type ComponentDatasheetProps = {
    component?: Component;
    initialMode?: DatasheetMode;
    scrollable?: boolean;
};

const ComponentDatasheet: FC<ComponentDatasheetProps> = ({ component }) => {
    const mode = useDatasheetMode();

    const isNonElectricalComponent = isNonElectricalComponentType(component?.type);

    return (
        <Stack gap={40} w="100%">
            <Collateral />
            <CompatibleWith />
            <ReferenceDesigns />
            <General />
            <DistributorPricing />
            {isNonElectricalComponent ? null : <Electrical />}
            <Performance />
            <Communication />
            <Standards />
            <Mechanical />
            <Environmental />

            {mode !== DatasheetMode.VIEW && <Images />}
            <Files />
            <Certificates />
            {component && <Questions component={component} />}
            <ProductVariants />
        </Stack>
    );
};

const WrappedComponentDatasheet: FC<ComponentDatasheetProps> = ({
    initialMode = DatasheetMode.VIEW,
    scrollable,
    component,
    ...rest
}) => (
    <Datasheet initialMode={initialMode} scrollable={scrollable}>
        <ComponentDatasheet initialMode={initialMode} component={component} {...rest} />
    </Datasheet>
);

export { WrappedComponentDatasheet as ComponentDatasheet };
